<template>
    <div class="detail">
        <main class="box">
            <div class="title">
                <p class="d-title">{{Title}}</p>
                <p class="date">{{DisplayTime}} &nbsp;&nbsp;&nbsp;{{ClassName}}</p>
            </div>
            <div class="content-wrap">
                <div v-html="Content"></div>
                <div class="vip" v-show="data.status === 0" @click="handleTry('try')">会员专享</div>
            </div>

            <div class="desc">
                <p>【重要声明及风险提示】：</p>
                <p class="risk">本报告中的信息均来源于已公开的资料，我公司对这些信息的准确性及完整性不作任何保证。在任何情况下，报告中的信息或所表达的意见并不构成所述证券买卖建议。在任何情况下，我公司不就本报告中的任何内容对任何投资做出任何形式的担保。本报告版权归博览财经所有。未获得博览财经事先书面授权，任何人不得对本报告进行任何形式的发布、复制。如引用、刊发，需注明出处为“武汉博览财经信息技术股份有限公司”，且不得对本报告进行有悖原意的删节和修改。</p>
            </div>
        </main>

        <div class="back-top" @click="backTop" v-show="btnFlag">
            <img src="../assets/images/return_top.png" alt="" srcset="">
        </div>

        <vip v-if="VisiAble" ref="dialog"></vip>
    </div>
</template>

<script>
import Vip from "@/components/common/vip";
import { Detail, Combo } from "@/api/news";

export default {
    name: "Detail",
    components: {
        Vip
    },
    data() {
        return {
            data: [],
            Title: '',
            DisplayTime: '',
            ClassName: '',
            title: '',
            Content: '',
            id: this.$route.query.id,
            zqcode: this.$route.query.zqcode,
            btnFlag: true,
            VisiAble: true,
            name: '',
            contentData: '',
            comboData: [],
        }
    },
    created() {
        this.$emit('header', true);
        this.$emit('footer', true);
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop)

        this.$axios.post(this.$route.query.url, {
            "id": this.$route.query.id,
            "zqcode": this.$route.query.zqcode,
        }).then(response => {
            if (this.$route.query.apiType == 3) {
                this.Title = response.data.data.title;
                this.DisplayTime = response.data.data.createtime;
                this.Content = response.data.data.content;
                this.ClassName = response.data.data.classname;
            } else if (this.$route.query.apiType == 4) {
                this.Title = response.data.data.Title;
                this.DisplayTime = response.data.data.DisplayTime;
                this.Content = response.data.data.Intro;
                this.ClassName = response.data.data.ClassName;

            } else if (this.$route.query.apiType == 1) {
                this.Title = response.data.data.Title;
                this.DisplayTime = response.data.data.DisplayTime;
                this.Content = response.data.data.Content;
                this.ClassName = response.data.data.ClassName;
            }
            // console.log(this.data);

        }, error => {
            console.log('错误', error.message)
        })

    },
    methods: {
        handleTry(data) {
            const token = window.localStorage.getItem('token')
            if(!token){
                this.$message.warning('请先登录');
                this.$router.push({path: '/UCenter'});
            }else{
                // 已登录用户跳转至会员购买页
                this.$router.push({path: '/Member'});
            }
        },
        init: function () {
            let data = {
                id: this.id,
            };

        },
        backTop() {
            const that = this
            let timer = setInterval(() => {
                let isPeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16);
        },
        scrollToTop() {
            const that = this
            that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (that.scrollTop > 60) {
                that.btnFlag = true
            } else {
                that.btnFlag = false
            }
        },
    }
}
</script>

<style scoped>
.detail {
    margin-top: 80px;
    margin-bottom: 20px;
}

.box {
    width: 1200px;
    margin: 0 auto;
}

.title {
    background-color: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    padding: 31px 0 16px 60px;
    margin-top: 90px;
}

.d-title {
    font-size: 24px;
    font-weight: 600;
}

.date {
    font-size: 14px;
    color: #959595;
    margin-top: 15px;
}

.content-wrap {
    background-color: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    margin-top: 10px;
    padding: 31px 63px 15px 64px;
    font-size: 20px;
    line-height: 40px;
}

.content-wrap p,
.content-wrap span,
.content-wrap h1 {
    font-family: unset !important;
    font-size: 16px !important;
    line-height: 2em !important;
}

.vip {
    height: 40px;
    background-color: #001646;
    border-radius: 20px;
    color: white;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    margin: 30px auto;
    width: 50%;
    cursor: pointer;
}

.desc {
    background-color: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    margin-top: 30px;
    padding: 31px 63px 43px 64px;
    color: gray;
}

.cp-intro {
    margin-top: 10px;
    margin-bottom: 15px;
    line-height: 24px;
}

.risk {
    margin-top: 10px;
    line-height: 24px;
}

.back-top {
    position: fixed;
    right: 40px;
    bottom: 40px;
    cursor: pointer;
    z-index: 9999;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetailTwo.vue